import { Component, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { QueryService } from '../../comun/services/query.service';
import { GlobalConstants } from '../../global-constants';

@Component({
  selector: 'app-header-buscar',
  templateUrl: './header-buscar.component.html',
  styleUrl: './header-buscar.component.css'
})
export class HeaderBuscarComponent implements AfterViewInit, OnDestroy {
  @ViewChild('inputBusqueda') input?: ElementRef<HTMLInputElement>;
  busqueda: { nombre: string; sexo: string; tipo: string; tamano: string } = {
    nombre: '', sexo: '', tipo: '', tamano: ''
  };
  tipos_mascotas: any[] = [];
  private modalElement: HTMLElement | null = null;
  private originalParent: Node | null = null;
  private originalNextSibling: Node | null = null;
  private onModalShown = () => this.input?.nativeElement.focus();

  constructor(private query: QueryService) {}

  get hayFiltros(): boolean {
    return !!(this.busqueda.nombre.trim() || this.busqueda.sexo || this.busqueda.tipo || this.busqueda.tamano);
  }

  ngAfterViewInit(): void {
    this.getTiposMascotas();
    this.modalElement = document.getElementById('modalBusqueda');
    if (this.modalElement) {
      // Bootstrap coloca el backdrop como hijo de <body>.
      // Un modal dentro del header sticky queda atrapado en su stacking context
      // (z-index: 1040) y se ve POR DETRAS del backdrop (z-index: 1050).
      // Trasladar el modal a <body> evita el problema sin quitar el sticky.
      this.originalParent = this.modalElement.parentNode;
      this.originalNextSibling = this.modalElement.nextSibling;
      document.body.appendChild(this.modalElement);
      this.modalElement.addEventListener('shown.bs.modal', this.onModalShown);
    }
  }

  ngOnDestroy(): void {
    this.modalElement?.removeEventListener('shown.bs.modal', this.onModalShown);
    // Restaurar el nodo antes de que Angular desmonte su vista.
    if (this.modalElement && this.originalParent) {
      if (this.originalNextSibling?.parentNode === this.originalParent) {
        this.originalParent.insertBefore(this.modalElement, this.originalNextSibling);
      } else {
        this.originalParent.appendChild(this.modalElement);
      }
    }
  }

  getTiposMascotas(): void {
    this.query.query('mascotas', 'TIPOS', null).subscribe({
      next: (resultado: any) => {
        if (resultado?.resultado === 'OK') this.tipos_mascotas = resultado.registros ?? [];
      },
      error: () => { this.tipos_mascotas = []; }
    });
  }

  limpiar(): void {
    this.busqueda = { nombre: '', sexo: '', tipo: '', tamano: '' };
    this.input?.nativeElement.focus();
  }

  buscar(): void {
    if (!this.hayFiltros) return;

    const params = new URLSearchParams();
    const nombre = this.busqueda.nombre.trim();
    if (nombre) params.set('no', nombre);
    if (this.busqueda.sexo) params.set('se', this.busqueda.sexo);
    if (this.busqueda.tipo) params.set('ti', this.busqueda.tipo);
    if (this.busqueda.tamano) params.set('ta', this.busqueda.tamano);

    const baseUrl = GlobalConstants.urlServer.replace(/\/+$/, '');
    window.location.href = `${baseUrl}/perfiles/?${params.toString()}`;
  }
}
